import React, { useEffect } from 'react';
import './../styles/service-page.css';
import DrivewayBeforeImg from './../../public/images/driveway_before.png';
import DrivewayAfterImg from './../../public/images/driveway_after.png';


const DrivewayWashingPage = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);

    // Parallax effect for hero background
    // const handleScroll = () => {
    //   const scrolled = window.scrollY;
    //   const heroBackground = document.querySelector('.hero-section');
    //   if (heroBackground && scrolled < 600) {
    //     const yPos = -(scrolled * 0.5);
    //     heroBackground.style.backgroundPositionY = `${yPos}px`;
    //   }
    // };

    // window.addEventListener('scroll', handleScroll);

    // Add scroll animations matching homepage
    const observeElements = () => {
      const elements = document.querySelectorAll('.slide-in-up, .slide-in-left, .slide-in-right');
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      elements.forEach(element => {
        observer.observe(element);
      });

      // Stagger animations for service cards
      const cards = document.querySelectorAll('.service-card');
      cards.forEach((card, index) => {
        card.style.transitionDelay = `${index * 0.1}s`;
      });

      // Stagger process steps
      const steps = document.querySelectorAll('.process-step');
      steps.forEach((step, index) => {
        step.style.transitionDelay = `${index * 0.15}s`;
      });
    };

    setTimeout(observeElements, 100);

    // Cleanup
    // return () => {
    //   window.removeEventListener('scroll', handleScroll);
    // };
  }, []);

  return (
    <div className="service-page">
      {/* Hero Section with Background Image */}
      <section 
        className="hero-section"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),url('https://media.istockphoto.com/id/1326032210/photo/garden-paved-path-floor-slabs-interlock-half-clean-and-dirty-after-an-anti-foam-cleaning.jpg?s=612x612&w=0&k=20&c=CGeoGLNzoYPTYUifTfoGZlIPlmXnHGkBdxNiUw7nFDo=')`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="hero-overlay"></div>
        <div className="container">
          <div className="header-content slide-in-up">
            <h1>Professional Driveway Washing</h1>
            <p className="header-subtitle">
              Expert pressure washing services to restore your driveway's appearance. 
              Remove oil stains, dirt, and grime with our professional cleaning solutions.
            </p>
          </div>
        </div>
      </section>

      {/* Service Overview */}
      <section className="service-overview">
        <div className="container">
          <div className="overview-grid">
            <div className="overview-content slide-in-left">
              <h2>Why Choose Our Driveway Cleaning Service?</h2>
              <p>
                Your driveway is one of the first things visitors notice about your property. 
                Over time, oil stains, dirt, algae, and general wear can make even the most 
                well-maintained driveway look neglected and reduce your property's kerb appeal.
              </p>
              <p>
                Our professional driveway cleaning service uses commercial-grade equipment 
                and proven techniques to safely remove even the most stubborn stains without 
                damaging your driveway surface. We work with all types of driveway materials 
                including concrete, block paving, tarmac, and natural stone.
              </p>
              <div className="key-benefits">
                <div className="benefit-item">
                  <span className="benefit-icon">✓</span>
                  <span>Removes stubborn oil and grease stains</span>
                </div>
                <div className="benefit-item">
                  <span className="benefit-icon">✓</span>
                  <span>Safe for all driveway materials</span>
                </div>
                <div className="benefit-item">
                  <span className="benefit-icon">✓</span>
                  <span>Eco-friendly cleaning solutions</span>
                </div>
                <div className="benefit-item">
                  <span className="benefit-icon">✓</span>
                  <span>Fully insured and guaranteed</span>
                </div>
              </div>
            </div>
            <div className="overview-image slide-in-right">
              <img src="https://media.istockphoto.com/id/2193979974/photo/cobblestone-street.jpg?s=612x612&w=0&k=20&c=jqU1ROsZ03QY47lSxYAjvnt032DT-ruPxgVwrEh8zDk=" alt="Professional driveway cleaning in progress" />
            </div>
          </div>
        </div>
      </section>

      {/* Before & After Gallery */}
      <section className="before-after-gallery">
        <div className="container">
          <h2 className="section-title slide-in-up">See the Transformation</h2>
          <p className="section-subtitle slide-in-up">
            Our professional driveway cleaning service delivers remarkable results every time
          </p>
          
          <div className="before-after-grid">
            {/* First Before/After Set */}
            <div className="before-after-item slide-in-left">
              <div className="comparison-container">
                <div className="before-image">
                  <img 
                    src={DrivewayBeforeImg}
                    alt="Driveway before cleaning - stained and dirty concrete"
                  />
                  <span className="image-label">Before</span>
                </div>
                <div className="after-image">
                  <img 
                    src={DrivewayAfterImg}
                    alt="Driveway after cleaning - clean and restored concrete"
                  />
                  <span className="image-label">After</span>
                </div>
              </div>
              <div className="transformation-caption">
                <h3>Concrete Driveway Restoration</h3>
                <p>Complete removal of oil stains and years of built-up grime</p>
              </div>
            </div>

            {/* Second Before/After Set */}
            {/* <div className="before-after-item slide-in-right">
              <div className="comparison-container">
                <div className="before-image">
                  <img 
                    src="https://media.istockphoto.com/id/1326032210/photo/garden-paved-path-floor-slabs-interlock-half-clean-and-dirty-after-an-anti-foam-cleaning.jpg?s=612x612&w=0&k=20&c=CGeoGLNzoYPTYUifTfoGZlIPlmXnHGkBdxNiUw7nFDo=" 
                    alt="Block paving before cleaning - moss and dirt buildup"
                  />
                  <span className="image-label">Before</span>
                </div>
                <div className="after-image">
                  <img 
                    src="https://media.istockphoto.com/id/1411598886/photo/outdoor-floor-cleaning-with-a-pressure-washer.jpg?s=612x612&w=0&k=20&c=cJOQ4pCPMEFN4ODaS6F5_QGS5RxdVaXTK6hfUgDz5Nk=" 
                    alt="Block paving after cleaning - restored to original colour"
                  />
                  <span className="image-label">After</span>
                </div>
              </div>
              <div className="transformation-caption">
                <h3>Block Paving Revival</h3>
                <p>Moss and algae removed, original colour fully restored</p>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      {/* What's Included */}
      <section className="whats-included">
        <div className="container">
          <h2 className="section-title slide-in-up">What's Included in Our Driveway Cleaning Service</h2>
          
          <div className="services-grid">
            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>🔍</span>
              </div>
              <h3>Initial Assessment</h3>
              <p>
                We start with a thorough inspection of your driveway to identify the surface type, 
                stain severity, and determine the most effective cleaning approach for optimal results.
              </p>
            </div>

            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>🧽</span>
              </div>
              <h3>Pre-Treatment</h3>
              <p>
                Stubborn stains and heavily soiled areas receive specialized pre-treatment solutions 
                to break down oil, grease, and embedded dirt before the main cleaning process.
              </p>
            </div>

            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>💨</span>
              </div>
              <h3>Pressure Washing</h3>
              <p>
                Using professional-grade pressure washing equipment, we systematically clean your 
                entire driveway with the appropriate pressure settings for your surface material.
              </p>
            </div>

            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>🛡️</span>
              </div>
              <h3>Post-Clean Protection</h3>
              <p>
                After cleaning, we can apply protective treatments to help prevent future staining 
                and make ongoing maintenance easier (available as an optional extra).
              </p>
            </div>

            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>♻️</span>
              </div>
              <h3>Eco-Safe Products</h3>
              <p>
                All our cleaning products are environmentally friendly and safe for your family, 
                pets, and surrounding landscaping while still being tough on dirt and stains.
              </p>
            </div>

            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>✅</span>
              </div>
              <h3>Quality Guarantee</h3>
              <p>
                We stand behind our work with a complete satisfaction guarantee. If you're not 
                happy with the results, we'll return to address any concerns at no extra cost.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Process */}
      <section className="our-process">
        <div className="container">
          <h2 className="section-title slide-in-up">Our Simple 4-Step Process</h2>
          
          <div className="process-steps">
            <div className="process-step slide-in-left">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Free Quote & Assessment</h3>
                <p>
                  Contact us for a free, no-obligation quote. We'll assess your driveway's 
                  condition and provide you with a detailed estimate of the work required.
                </p>
              </div>
            </div>

            <div className="process-step slide-in-right">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Preparation & Setup</h3>
                <p>
                  We'll protect your property and surrounding areas, then apply pre-treatment 
                  solutions to problem areas and set up our professional cleaning equipment.
                </p>
              </div>
            </div>

            <div className="process-step slide-in-left">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Professional Cleaning</h3>
                <p>
                  Using the correct pressure settings for your driveway material, we systematically 
                  clean every area, paying special attention to stained and heavily soiled sections.
                </p>
              </div>
            </div>

            <div className="process-step slide-in-right">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Final Inspection</h3>
                <p>
                  We conduct a thorough quality check to ensure all areas have been properly cleaned, 
                  and discuss optional protective treatments to maintain your driveway's appearance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content slide-in-up">
            <h2>Ready to Restore Your Driveway?</h2>
            <p>
              Get your free quote today and see how we can transform your driveway's appearance. 
              Most quotes provided within 24 hours with no obligation to proceed.
            </p>
            <div className="cta-buttons">
              <a href="/#contact" className="btn btn-primary">Get Free Quote</a>
            </div>
            <div className="cta-assurance">
              <span>✓ Fully insured</span>
              <span>✓ Satisfaction guaranteed</span>
              <span>✓ Free quotes</span>
              <span>✓ No hidden fees</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DrivewayWashingPage;